import { useEffect, useRef, useState } from "react";

const R = 46;

export function Joystick({ moveRef }) {
  const base = useRef(null);
  const active = useRef(null);
  const [knob, setKnob] = useState({ x: 0, y: 0 });
  // while the pad is on screen, the bottom-left cues lift above it (see the [.walkpad_&] classes)
  useEffect(() => {
    document.documentElement.classList.add("walkpad");
    return () => document.documentElement.classList.remove("walkpad");
  }, []);

  const update = (e) => {
    const r = base.current.getBoundingClientRect();
    let dx = e.clientX - (r.left + r.width / 2);
    let dy = e.clientY - (r.top + r.height / 2);
    const d = Math.hypot(dx, dy);
    if (d > R) {
      dx *= R / d;
      dy *= R / d;
    }
    setKnob({ x: dx, y: dy });
    moveRef.current = { x: dx / R, y: dy / R };
  };
  const end = () => {
    active.current = null;
    setKnob({ x: 0, y: 0 });
    moveRef.current = { x: 0, y: 0 };
  };

  return (
    <div
      ref={base}
      data-testid="mobile-joystick-pad"
      className="fixed bottom-10 left-8 z-40 h-32 w-32 [@media(max-height:500px)]:left-16 touch-none select-none rounded-full border border-[#B39DDB]/70 bg-white/60 backdrop-blur-md"
      onPointerDown={(e) => {
        e.stopPropagation();
        e.currentTarget.setPointerCapture(e.pointerId);
        active.current = e.pointerId;
        update(e);
      }}
      onPointerMove={(e) => active.current === e.pointerId && update(e)}
      onPointerUp={end}
      onPointerCancel={end}
    >
      <div className="pointer-events-none absolute inset-3 rounded-full border border-[#7E57C2]/10" />
      <div
        data-testid="mobile-joystick-knob"
        className="pointer-events-none absolute left-1/2 top-1/2 h-12 w-12 rounded-full border border-[#7E57C2]/50 bg-[#7E57C2]/20 shadow-[0_0_24px_rgba(126,87,194,0.35)]"
        style={{ transform: `translate(calc(-50% + ${knob.x}px), calc(-50% + ${knob.y}px))` }}
      />
    </div>
  );
}
